H5PaymentProxy = xClass("H5PaymentProxy")
var _proxy = null
H5PaymentProxy.getInstance = function () {
    if (_proxy) {
        return _proxy
    }
    if (window.META.user.platform == XcloverPlatform.qq ||
        window.META.user.platform == XcloverPlatform.weixin) {
        _proxy = require("clover/sns/playzonePayment")
    } else if (window.META.user.platform == XcloverPlatform.huawei) {
        _proxy = require("clover/sns/HuaweiQuickgamePaymentNew").create()
    }else if (window.META.user.platform == 'he') {
        // _proxy = require("clover/sns/HuaweiQuickgamePaymentNew").create()
        _proxy = H5PaymentProxy.create()
    } else if (META.platform == XcloverPlatform.wechatgame) {
        if (window.qq){
            console.log("[#############]user qqlightgame payment")
            _proxy = require("clover/sns/QQlightgamePayment").create()
        }else if (mini.getPlatform() == MiniPlatform.oppoQuickgame){ 
            _proxy = require("clover/sns/OppoQuickgamePayment").create()
        }else if (mini.getPlatform() == MiniPlatform.honorQuickgame){ 
            _proxy = require("clover/sns/HonorQuickgamePayment").create()
        }else if (mini.getPlatform() == MiniPlatform.baidu){
            _proxy = require("clover/sns/BaiduLightgamePayment").create()
        }else if (mini.getPlatform() == MiniPlatform.vivo){
            _proxy = require("clover/sns/VivoQuickgamePayment").create()
        }else if (mini.getPlatform() == MiniPlatform.tt){
            _proxy = require("clover/sns/TTlightgamePayment").create()
        }else if (mini.getPlatform() == MiniPlatform.mi){
            _proxy = require("clover/sns/MiQuickgamePayment").create()
        }else if (mini.getPlatform() == MiniPlatform.ks){
            _proxy = require("clover/sns/KsQuickgamePayment").create()
        }else{
            _proxy = require("clover/sns/WechatgamePayment").create()
        }
    } else {
        _proxy = H5PaymentProxy.create()
    }
    return _proxy
}

H5PaymentProxy.prototype.buy = function (data, successCallback, failCallback, closeCallback) {
    if (__DEV) {
        setTimeout(function (){
            successCallback && successCallback({orderId: `testDevOrderId_${Localhost.timeInSec()}`});
        }, 1000);
        return;
    }
    let ret = {
        code: -1,
        data: "暂时不支持当前平台！"
    }
    failCallback && failCallback(ret)
}

H5PaymentProxy.prototype.payStatusCheck = function (successCallback, failCallback) {
    let ret = {
        code: -1,
        data: "暂时不支持当前平台！"
    }
    UserManager.getInstance().getPayConfigHW()
    failCallback && failCallback(ret)
}

module.exports = H5PaymentProxy;